import { postRequest } from '../../httpClient';
import type { IUploadCollectionMediaResponse } from './upload-collection-media-response';
import { uploadCollectionMediaResponseSchema } from './upload-collection-media-response';

export async function uploadCollectionMediaApi(
  collectionId: number,
  fieldName: string,
  file: File,
): Promise<IUploadCollectionMediaResponse> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('fieldName', fieldName);

  const result = await postRequest<IUploadCollectionMediaResponse>({
    path: `/sys/collections/${collectionId}/upload-media`,
    body: formData,
    schema: uploadCollectionMediaResponseSchema,
  });
  return result.data;
}
